/**
 * Props for the GaugeChart.Tooltip slot component
 * @public
 */
export interface GaugeChartTooltipProps {
  /**
   * Optional name to display in the tooltip
   */
  name?: string;
}

/**
 * Slot component for Gauge Chart tooltip
 * @public
 */
export const Tooltip = (props: GaugeChartTooltipProps) => null;

Tooltip['displayName'] = 'GaugeChart.Tooltip';
